export const LISTENER_QUALIFIER = "on";
export const LISTENER_QUALIFIER_REGEX = new RegExp(`^${LISTENER_QUALIFIER}(\\w+)`);